var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import CommonTable from '../../components/commonTableComponent/CommonTable';
import TabSectionCard from './components/TabSectionCard';
import { getCommaSeparatedForAmounts } from '../../utils/commonUtilities';
import { baseColors } from '../../Themes/colors';
import { FinancingAndAdjustmentsTable } from '../../config/TableColumns';
var financingColumns = FinancingAndAdjustmentsTable.map(function (col) { return ({
    key: col.apiKey,
    header: col.label,
}); });
var FinancingAdjustments = function (_a) {
    var assetResp = _a.assetResp, _roleType = _a.roleType, _hasEditAccess = _a.hasEditAccess, _onDataRefresh = _a.onDataRefresh;
    var financedItems = assetResp.FinancingAndAdjustmets
        .filter(function (item) { return item.Section === 'Principal'; })
        .map(function (item) { return (__assign(__assign({}, item), { UnitAmount: typeof item.UnitAmount === 'number'
            ? getCommaSeparatedForAmounts(item.UnitAmount)
            : '--', TotalAmount: typeof item.Quantity === 'number' && typeof item.UnitAmount === 'number'
            ? getCommaSeparatedForAmounts(item.Quantity * item.UnitAmount)
            : '--' })); });
    var adjustmentItems = assetResp.FinancingAndAdjustmets
        .filter(function (item) { return item.Section === 'Adjustments'; })
        .map(function (item) { return (__assign(__assign({}, item), { UnitAmount: typeof item.UnitAmount === 'number'
            ? getCommaSeparatedForAmounts(item.UnitAmount)
            : '--', TotalAmount: typeof item.Quantity === 'number' && typeof item.UnitAmount === 'number'
            ? getCommaSeparatedForAmounts(item.Quantity * item.UnitAmount)
            : '--' })); });
    var _b = assetResp.FinancingAndAdjustmets.reduce(function (acc, item) {
        var amount = item.UnitAmount || 0;
        if (item.Section === 'Principal')
            acc.principalSum += amount;
        else if (item.Section === 'Adjustments')
            acc.adjustmentSum += amount;
        return acc;
    }, { principalSum: 0, adjustmentSum: 0 }), principalSum = _b.principalSum, adjustmentSum = _b.adjustmentSum;
    return (React.createElement(TabSectionCard, { title: "Financing and Adjustments" },
        React.createElement(Stack, { gap: 3 },
            React.createElement(Box, null,
                React.createElement(Typography, { variant: "body2", fontWeight: 600, pb: 1.5, color: baseColors.bluePreset[10] },
                    "Financed Items:",
                    ' ',
                    React.createElement(Typography, { variant: "body2", component: "span", fontWeight: 400 }, principalSum ? getCommaSeparatedForAmounts(principalSum) : '$0.00')),
                React.createElement(CommonTable, { columns: financingColumns, data: financedItems, keyExtractor: function (row, i) { var _a; return "financed-".concat((_a = row.ContractOid) !== null && _a !== void 0 ? _a : i); }, emptyMessage: "No financed items found." })),
            React.createElement(Box, null,
                React.createElement(Typography, { variant: "body2", fontWeight: 600, pb: 1.5, color: baseColors.bluePreset[10] },
                    "Adjustment Items:",
                    ' ',
                    React.createElement(Typography, { variant: "body2", component: "span", fontWeight: 400 }, adjustmentSum ? getCommaSeparatedForAmounts(adjustmentSum) : '$0.00')),
                React.createElement(CommonTable, { columns: financingColumns, data: adjustmentItems, keyExtractor: function (row, i) { var _a; return "adjustment-".concat((_a = row.ContractOid) !== null && _a !== void 0 ? _a : i); }, emptyMessage: "No adjustment items found." })))));
};
export default FinancingAdjustments;
